// src/pages/Users/Messaging/GroupMessages.jsx
import React, { useState } from "react";
import { FaLayerGroup } from "react-icons/fa";
import { LuMessageSquarePlus } from "react-icons/lu";
import CreateMessageGroupForm from "./CreateMessageGroupForm";

export default function GroupMessages({ userId }) {
  const [showGroupForm, setShowGroupForm] = useState(false);

  return (
    <div className="rounded-2xl overflow-hidden shadow ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white/80 dark:bg-slate-900/60 backdrop-blur">
      {/* Header sobre (plus de dégradé ici) */}
      <div className="px-4 py-3 bg-slate-50 dark:bg-slate-800/60 text-slate-800 dark:text-slate-100">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <FaLayerGroup className="text-lg" />
            <h3 className="text-base sm:text-lg font-semibold">Messages groupés</h3>
          </div>

          <button
            type="button"
            onClick={() => setShowGroupForm((v) => !v)}
            className="inline-flex items-center gap-1 rounded-lg px-3 py-2 text-xs sm:text-sm ring-1 ring-slate-300 dark:ring-slate-700 text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition"
            title={showGroupForm ? "Fermer le formulaire" : "Nouveau message groupé"}
          >
            <LuMessageSquarePlus className="text-[14px]" />
            <span className="hidden sm:inline">
              {showGroupForm ? "Fermer" : "Nouveau / Voir"}
            </span>
          </button>
        </div>
      </div>

      {/* Corps */}
      <div className="p-4 sm:p-6">
        {showGroupForm ? (
          <CreateMessageGroupForm
            userId={userId}
            onHide={() => setShowGroupForm(false)}
            onSent={() => setShowGroupForm(false)}
          />
        ) : (
          <div className="text-sm text-slate-600 dark:text-slate-300">
            Cliquez sur <span className="font-semibold">Nouveau / Voir</span> pour
            envoyer un message à un groupe.
          </div>
        )}
      </div>
    </div>
  );
}
